'use strict'
import { codeData } from '@/utils/codeData';


const asset = {
    path: 'recharges-manage',
    name: 'recharges-manage',
    meta: {
        title: '充值管理-资产管理-综合服务平台',
        name: '充值管理',
        tagsTitle: '充值管理',
        code: ''
    },
    redirect: {
        name: 'recharges-list'
    },
    component: () => import('@/components/RouterView'),
    children: [
        {
            path: 'recharges-list',
            name: 'recharges-list',
            meta: {
                title: '充值记录-资产管理-综合服务平台',
                name: '',
                tagsTitle: '充值管理',
                code: ''
            },
            component: () => import('@/pages/recharges/RechargeList'),
        },
        {
            path: 'recharge-detail/:id',
            name: 'recharge-detail',
            meta: {
                title: '充值详情-资产管理-综合服务平台',
                name: '充值详情',
                tagsTitle: '充值详情',
                code: ''
            },
            component: () => import('@/pages/recharges/RechargeDetail'),
        },
    ]
};

export default asset;